function getFileName() {
	const fileInput = document.getElementById('vacancy-file');
	const fileOutput = document.querySelector('.general-form__item--file small');

	fileInput.addEventListener('change', function() {
		fileOutput.innerText = fileInput.value.replace(/^.*[\\\/]/, '');
	});
}
